var __jsx = React.createElement;
import React from 'react';
import Divider from '@mui/material/Divider';
import { StyledDrawer } from './style';
// import { organisationList } from './Lists';
import Lists from './Lists';
import { USER_ROLES } from '../../../../config/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Sidebar = function Sidebar(_ref) {
  var isOpen = _ref.isOpen,
    userInfo = _ref.userInfo;
  return /*#__PURE__*/_jsxs(StyledDrawer, {
    variant: "permanent",
    open: isOpen,
    children: [userInfo && userInfo.role.name !== USER_ROLES.USER && /*#__PURE__*/_jsx(Lists.organisationList, {}), userInfo && userInfo.role && /*#__PURE__*/_jsx(Lists.GeneralList, {
      role: userInfo.role.name,
      hasReviews: userInfo.has_reviews
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
};
Sidebar.defaultProps = {
  isOpen: false
};
export default Sidebar;